var r="right-scroll-bar-position",o="width-before-scroll-bar",l="with-scroll-bars-hidden",e="--removed-body-scroll-bar-size";export{o as fullWidthClassName,l as noScrollbarsClassName,e as removedBarSizeVariable,r as zeroRightClassName};
//# sourceMappingURL=constants.js.map
